var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { service } from '@ember/service';
import { waitForPromise } from '@ember/test-waiters';
let SearchService = (_class = class SearchService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "iliosConfig", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
  }
  get authHeaders() {
    const session = this.session;
    const {
      jwt
    } = session.data.authenticated;
    const headers = {};
    if (jwt) {
      headers['X-JWT-Authorization'] = `Token ${jwt}`;
    }
    return new Headers(headers);
  }
  get host() {
    return this.iliosConfig.apiHost ? this.iliosConfig.apiHost : window.location.protocol + '//' + window.location.host;
  }

  /**
   * Find courses
   * @param {string} q
   */
  async forCurriculum(q, onlySuggestEnabled = false) {
    return this.search('curriculum', q, 1000, onlySuggestEnabled);
  }

  /**
   * Find users
   * @param {string} q
   * @param {number} size
   */
  async forUsers(q, size = 100, onlySuggestEnabled = false) {
    const {
      users,
      autocomplete
    } = await this.search('users', q, size, onlySuggestEnabled);
    const mappedUsers = users.map(user => {
      user.fullName = this.getUserFullName(user);
      return user;
    });
    return {
      autocomplete,
      users: mappedUsers
    };
  }
  async search(type, q, size, onlySuggestEnabled) {
    const onlySuggest = onlySuggestEnabled ? '&onlySuggest=true' : '';
    const url = `${this.host}/api/search/v1/${type}?q=${q}&size=${size}${onlySuggest}`;
    const response = await waitForPromise(fetch(url, {
      headers: this.authHeaders
    }));
    const {
      results
    } = await response.json();
    return results;
  }
  getUserFullName(user) {
    if (user.displayName) {
      return user.displayName;
    }
    if (!user.firstName || !user.lastName) {
      return '';
    }
    const middleInitial = user.middleName ? user.middleName.charAt(0) : false;
    if (middleInitial) {
      return `${user.firstName} ${middleInitial}. ${user.lastName}`;
    } else {
      return `${user.firstName} ${user.lastName}`;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "iliosConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { SearchService as default };